import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import "@/App.css";

// Import all sections
import HeroSection from "./components/sections/HeroSection";
import WhyChooseSection from "./components/sections/WhyChooseSection";
import InstructorSection from "./components/sections/InstructorSection";
import ProgramSection from "./components/sections/ProgramSection";
import BenefitsSection from "./components/sections/BenefitsSection";
import TestimonialsSection from "./components/sections/TestimonialsSection";
import GuaranteeSection from "./components/sections/GuaranteeSection";
import PricingSection from "./components/sections/PricingSection";
import FinalCTASection from "./components/sections/FinalCTASection";
import FooterSection from "./components/sections/FooterSection";

function App() {
  // Initialize Lenis smooth scroll
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#030014] min-h-screen">
      <main data-testid="main-content">
        <HeroSection />
        <WhyChooseSection />
        <InstructorSection />
        <ProgramSection />
        <BenefitsSection />
        <TestimonialsSection />
        <GuaranteeSection />
        <PricingSection />
        <FinalCTASection />
        <FooterSection />
      </main>
    </div>
  );
}

export default App;
